<template>
  <el-dialog
      width="80%"
      title="所有专业"
      :visible.sync="innerVisible" top="2vh"
      append-to-body>
      <div style="height: 600px;overflow-y: scroll;">
        <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}"
          v-loading="loading">
          <el-table-column label="专业名称" align="center">
            <template slot-scope="scope">
               {{scope.row.specialty_title}}
            </template>
          </el-table-column>
          <el-table-column label="批次" align="center">
            <template slot-scope="scope">
               {{scope.row.batch}}
            </template>
          </el-table-column>
          <el-table-column label="组别" align="center">
            <template slot-scope="scope">
               {{scope.row.group_d}}
            </template>
          </el-table-column>
          <el-table-column label="次选科目" align="center">
            <template slot-scope="scope">
               {{scope.row.the_second}}
            </template>
          </el-table-column>
          <el-table-column label="专业方向" align="center">
            <template slot-scope="scope">
               {{scope.row.major_field}}
            </template>
          </el-table-column>
          <el-table-column label="专业简注" align="center">
            <template slot-scope="scope">
               {{scope.row.major_remark}}
            </template>
          </el-table-column>
          <el-table-column label="招生人数/学制" align="center">
            <template slot-scope="scope">
               {{scope.row.planned_number}}/{{scope.row.schooling_length}}
            </template>
          </el-table-column>
          <el-table-column label="学费" align="center">
            <template slot-scope="scope">
               {{scope.row.tuition_fee}}
            </template>
          </el-table-column>
      </el-table>
      </div>
  </el-dialog>
</template>

<script>
  import { Mojor_recodeList } from "@/api/gw/zonghe.js"
  export default {
     data(){
      return{
        innerVisible:false,
        list:[],
        recruitdata_id:"",
        loading:false,
      }
     },
     mounted(){

     },
     watch:{

     },
     methods:{
        show(recruitdata_id){
           this.$nextTick(()=>{
            this.innerVisible = true
            this.recruitdata_id = recruitdata_id
            this.Mojor_recodeList();
           })
        },
        Mojor_recodeList(){
           this.loading = true
           Mojor_recodeList({
            recruitdata_id:this.recruitdata_id
           }).then(res=>{
              this.list =  res.data
           }).finally(()=>{
            this.loading = false
           })
        },
     }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/major/components/zhuanye.vue